
import React from 'react';
import { Calendar, Clock3, MessageSquare } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { RsvpDetails } from '../hooks/useRsvpStatus';

interface RsvpDetailsPanelProps {
  details: RsvpDetails;
  displayDates: string[] | null;
  displayTimes: string[] | null;
}

export const RsvpDetailsPanel: React.FC<RsvpDetailsPanelProps> = ({ 
  details, 
  displayDates, 
  displayTimes 
}) => {
  if (!details) return null;

  return (
    <div className="mt-2 space-y-3 bg-gray-100 p-3 rounded-md">
      {displayDates && displayDates.length > 0 && (
        <div className="flex items-start gap-2">
          <Calendar className="h-4 w-4 text-gray-500 mt-0.5" />
          <div>
            <p className="text-xs font-medium text-gray-700">Preferred Dates</p>
            <div className="flex flex-wrap gap-1 mt-1">
              {displayDates.map((date, index) => (
                <Badge key={index} variant="outline" className="text-xs bg-white">
                  {date}
                </Badge>
              ))}
            </div>
          </div>
        </div>
      )}
      
      {displayTimes && displayTimes.length > 0 && (
        <div className="flex items-start gap-2">
          <Clock3 className="h-4 w-4 text-gray-500 mt-0.5" />
          <div>
            <p className="text-xs font-medium text-gray-700">Preferred Times</p>
            <div className="flex flex-wrap gap-1 mt-1">
              {displayTimes.map((time, index) => (
                <Badge key={index} variant="outline" className="text-xs bg-white">
                  {time}
                </Badge>
              ))}
            </div>
          </div>
        </div>
      )}
      
      {details.feedback_text && (
        <div className="flex items-start gap-2">
          <MessageSquare className="h-4 w-4 text-gray-500 mt-0.5" />
          <div>
            <p className="text-xs font-medium text-gray-700">Your Comments</p>
            <p className="text-xs text-gray-600 mt-1 whitespace-pre-line">
              {details.feedback_text}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
